import { Autocomplete, TextField } from '@mui/material'
import { useState } from 'react'
import { Danfe } from '../Danfe/danfe'
import { InvoiceTypes } from '../Danfe/danfeTypes'
import Modal from '../Modal'
import './resetStyles.css'

interface InvoiceSelectAndViewParams {
  nfList: string[]
  onChange?: (newValue: string) => void
}

export const InvoiceSelectAndView: React.FC<InvoiceSelectAndViewParams> = ({ nfList }) => {
  const [state, setState] = useState({ open: false, invoiceKey: null })

  const onSelect = (_, newValue) => {
    const regex = /Nota:\s(\[\d-]+)/
    const matches = newValue?.label.match(regex)
    setState({
      open: !!newValue,
      invoiceKey: matches[1],
    })
  }

  const hideModal = () => {
    setState({
      ...state,
      open: false,
    })
  }

  return (
    <>
      <Autocomplete
        options={nfList.map((item, index) => ({ label: item, id: index }))}
        sx={{ width: 800 }}
        onChange={onSelect}
        size='small'
        noOptionsText='Nenhuma nota encontrada'
        renderInput={(params) => <TextField {...params} label='Nota fiscal' data-testid='invoice-select' />}
      />
      {state.open && state.invoiceKey && (
      <Modal
        closeButtonAction={hideModal}
        size='lg'
        body={<Danfe invoiceKey={state.invoiceKey} type={InvoiceTypes.RECEIVEMENT} onError={hideModal}/>}
        title='Danfe'
        dialogClassName='customized-dialog'
        show={state.open}
        data-testid='invoice-view-modal'
      />
      )}
    </>
  )
}
